import { ContactUs } from '@/Contact-Us';
import { InsurancePlans } from '@/Insurance-Plans';
import { Footer } from '@/layout/Footer';
import { Nav } from '@/layout/Nav';
import React from 'react';

export const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    React.useEffect(() => {
        // @ts-nocheck
        (function (w: any, d: any, s: any, o: any, f: any, js: any, fjs: any) {
            w[o] =
                w[o] ||
                function () {
                    // eslint-disable-next-line prefer-rest-params
                    (w[o].q = w[o].q || []).push(arguments);
                };
            if (d.getElementById(o)) return;
            js = d.createElement(s);
            fjs = d.getElementsByTagName(s)[0];
            js.id = o;
            js.src = f;
            js.async = 1;
            if (fjs && fjs.parentNode) {
                fjs.parentNode.insertBefore(js, fjs);
            } else {
                d.head.appendChild(js);
            }
        })(window, document, 'script', '_hw', 'https://files.withcherry.com/widgets/widget.js');

        // @ts-ignore
        window._hw(
            'init',
            {
                debug: false,
                variables: {
                    slug: 'first-care-dental-associates',
                    name: 'First Care Dental Associates',
                    images: [21],
                    customLogo: 'https://firstcaredental.org/favicon-32x32.png',
                    defaultPurchaseAmount: 1000,
                    customImage: '',
                    imageCategory: 'dental',
                    language: 'en',
                },
                styles: {
                    primaryColor: '#59862c',
                    secondaryColor: '#e7f6d9',
                    fontFamily: 'Poppins',
                    headerFontFamily: 'Poppins',
                    floatingEstimator: {
                        position: 'bottom-right',
                        offset: {
                            x: '0px',
                            y: '0px',
                        },
                        zIndex: 9999,
                        ctaFontFamily: 'Poppins',
                        bodyFontFamily: 'Poppins',
                        ctaColor: '#59862c',
                        ctaTextColor: '#ffffff',
                    },
                },
            },
            ['floatingEstimator']
        );

        return () => {
            const scriptTag = document.getElementById('_hw');
            if (scriptTag) scriptTag.remove();
        };
    }, []);

    return (
        <main>
            <Nav />
            {children}
            <InsurancePlans />
            {/* <ScheduleYourFirstVisit /> */}
            <ContactUs />

            <div id="floatingEstimator"></div>

            <Footer />
        </main>
    );
};
